import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";

// import Favorite from "@material-ui/icons/Favorite";

import Header from "../../components/Header/Header.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Parallax from "../../components/Parallax/Parallax.jsx";
// import Footer from "../../components/Footer/Footer.jsx";
import HeaderLinks from "../../components/Header/HeaderLinks.jsx";

// import SectionDescription from "./Sections/SectionDescription.jsx";
// import SectionTeam from "./Sections/SectionTeam.jsx";
// import SectionServices from "./Sections/SectionServices.jsx";
import SectionPills from "./Sections/SectionPills";
// import SectionOffice from "./Sections/SectionOffice.jsx";
import FooterSection from "../LandingPage/Sections/FooterSection";
// import SectionContact from "./Sections/SectionContact";
// import SectionSponsors from "./Sections/SectionSponsors";

import { getTouristsTerms } from '../../actions/commonActions';

import aboutUsStyle from "../../assets/jss/material-kit-pro-react/views/aboutUsStyle.jsx";

class TermsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            touristsTerms: ''
        };

        this.props.getTouristsTerms();
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    }

    componentWillReceiveProps(nextProps) {
        if (!!nextProps.errors && !!nextProps.errors.message) {
            console.error(nextProps.errors.message);
            let errors = {};
            if (!!nextProps.errors.errors && nextProps.errors.errors.length>0) {
                for (let i=0; i<nextProps.errors.errors.length; i++) {
                    let actualField = nextProps.errors.errors[i];
                    errors[actualField.field] = actualField.message;
                }
                this.setState({ errors });
            }
        } else if (nextProps.commonReducer.touristsTerms !== this.state.touristsTerms) {
            this.setState({ touristsTerms: nextProps.commonReducer.touristsTerms, errors: {} });
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Términos y Condiciones Turistas | Vivamos el Campo - Turismo Rural</title>
                    <link rel="canonical" href="https://vivamoselcampo.co/terminos-y-condiciones" />
                    <meta name="description" content="Como usuario de Vivamos el Campo - Turismo Rural cuentas con derechos y deberes, conócelos en los siguientes Términos y Condiciones" />
                </Helmet>

                <Header
                    fixed
                    brand="Vivamos el Campo Logo"
                    color="transparent"
                    links={<HeaderLinks dropdownHoverColor="info"/>}
                    changeColorOnScroll={{
                        height: 180,
                        color: "white"
                    }}
                />
                <Parallax image={require("../../assets/img/landing-bg.jpg")} filter="dark" small>
                    <div className={classes.container}>
                        <GridContainer justify="center">
                            <GridItem md={8} sm={8} className={classNames(classes.mlAuto, classes.mrAuto, classes.textCenter)}>
                                <h1 className={classes.title}>Términos y Condiciones</h1>
                                <h4>
                                    Turistas
                                </h4>
                            </GridItem>
                        </GridContainer>
                    </div>
                </Parallax>
                <div className={classNames(classes.main, classes.mainRaised)}>
                    <div className={classes.container}>
                        <SectionPills touristsTerms={this.state.touristsTerms} />
                    </div>
                </div>

                <FooterSection />
            </div>
        );
    }
}

TermsPage.propTypes = {
    getTouristsTerms: PropTypes.func.isRequired,
    commonReducer: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    commonReducer: state.commonReducer,
    errors: state.errors
});

export default connect(mapStateToProps, { getTouristsTerms })( withStyles(aboutUsStyle)(TermsPage) );



// WEBPACK FOOTER //
// ./src/views/TermsPage/TermsPage.js